/**
 * Índices fraccionales para ordenar sin reescribir toda la lista (FR-ORG-03).
 * Claves en base 36 que nunca terminan en '0'; se comparan lexicográficamente.
 */
const DIGITS = '0123456789abcdefghijklmnopqrstuvwxyz';
const BASE = DIGITS.length;

function midpoint(a: string, b: string | null): string {
  if (b !== null && a >= b) throw new Error(`${a} >= ${b}`);
  if (b !== null) {
    let n = 0;
    while ((a[n] ?? '0') === b[n]) n++;
    if (n > 0) return b.slice(0, n) + midpoint(a.slice(n), b.slice(n));
  }
  const da = a ? DIGITS.indexOf(a[0]!) : 0;
  const db = b !== null ? DIGITS.indexOf(b[0]!) : BASE;
  if (db - da > 1) return DIGITS[Math.round((da + db) / 2)]!;
  if (b !== null && b.length > 1) return b.slice(0, 1);
  return DIGITS[da]! + midpoint(a.slice(1), null);
}

/** Clave estrictamente entre `a` y `b` (null = extremo abierto). */
export function keyBetween(a: string | null, b: string | null): string {
  return midpoint(a ?? '', b);
}

/** Clave para insertar al final de una lista ordenada. */
export function keyAfter(last: string | null): string {
  return keyBetween(last, null);
}
